'use strict';

const asyncInitializer = require('../initializers/async_initializer');
const getBaseAsyncFiles = require('./base');

const init = (payload, done) => {
  const modulePromises = [...getBaseAsyncFiles(payload)];

  if (payload.liveChat) {
    modulePromises.push(
      import(/* webpackChunkName: "live_chat" */ './loaders/live_chat')
    );
  }
  if (payload.loadSwitch && payload.loadSwitch.shouldLoadDeliveryEstimates) {
    modulePromises.push(
      import(
        /* webpackChunkName: "delivery_estimates" */ './loaders/delivery_estimates'
      )
    );
  }
  if (payload.multipleBuyingOptions) {
    modulePromises.push(
      import(
        /* webpackChunkName: "multiple_buying_options" */ '../../../../modules/multiple_buying_options/frontend'
      )
    );
  }
  if (
    payload.goodsUrgencyProminence &&
    payload.goodsUrgencyProminence.urgencyProminence
  ) {
    modulePromises.push(
      import(
        /* webpackChunkName: "urgency_prominence_desktop" */ './loaders/urgency_prominence_desktop'
      )
    );
  }
  if (payload.freeShipping) {
    modulePromises.push(
      import(
        /* webpackChunkName: "goods_free_shipping" */ '../../../../modules/goods_free_shipping/frontend'
      )
    );
  }
  if (
    payload.loadSwitch &&
    payload.loadSwitch.shouldShowTipWidget &&
    payload.tipWidgetV2
  ) {
    modulePromises.push(
      import(/* webpackChunkName: "tip_widget_v2" */ './loaders/tip_widget_v2')
    );
  }

  if (payload.ugcPhotos && payload.ugcPhotos.ids.length) {
    modulePromises.push(
      import(/* webpackChunkName: "ugc_photos" */ './loaders/ugc_photos')
    );
  }

  asyncInitializer(modulePromises, 40 * 1000, initStart => {
    if (
      typeof window.BOOMR !== 'undefined' &&
      typeof window.BOOMR.addVar === 'function'
    ) {
      window.BOOMR.addVar(
        'deal_page_async_modules_loaded',
        new Date() - initStart
      );
    }
  });

  return done();
};

module.exports = { init };
